import { useFriends } from '../../contexts/FriendsContext';
import Button from '../ui/Button';

function Friend({ friend }) {
  const { selectedFriend, dispatch } = useFriends();

  const isSelected = selectedFriend?.id === friend.id;

  function handleClick() {
    dispatch({ type: 'selectedFriend', payload: friend });
  }

  return (
    <li className={isSelected ? 'selected' : ''}>
      <img src={friend.image} alt={friend.name} />

      <h3>{friend.name}</h3>

      {friend.balance < 0 && (
        <p className="red">
          You owe {friend.name} {Math.abs(friend.balance)}৳
        </p>
      )}

      {friend.balance > 0 && (
        <p className="green">
          {friend.name} owes you {Math.abs(friend.balance)}৳
        </p>
      )}

      {friend.balance === 0 && <p>You and {friend.name} are even </p>}

      <Button onClick={handleClick}>{isSelected ? 'Close' : 'Select'}</Button>
    </li>
  );
}

export default Friend;
